import React, { FC, useEffect, useState } from 'react';
import { IPollGetByIdResponse } from 'shared/types/poll.types';
import moment from 'moment';
import { PICKER_DATE_MASK, SERVER_DATE_MASK } from 'shared/constants';
import { PollTabsToRus } from 'shared/enums/poll';
import style from './index.module.scss';

type TPollCommonInfoProps = {
  currentPoll: IPollGetByIdResponse;
};

const CommonInfo: FC<TPollCommonInfoProps> = ({ currentPoll }) => {
  const [isForAllEmployees, setIsForAllEmployees] = useState<boolean>(true);
  const [isForDivisions, setIsForDivisions] = useState<boolean>(true);
  const [isForOrganizations, setIsForOrganizations] = useState<boolean>(true);

  useEffect(() => {
    const isForDivisionsLocal = currentPoll?.divisions?.length
      ? currentPoll?.divisions[0] === null
        ? false
        : true
      : false;
    const isForOrganizationsLocal = currentPoll.organizations?.length
      ? currentPoll.organizations[0] === null
        ? false
        : true
      : false;

    setIsForOrganizations(isForOrganizationsLocal);
    setIsForDivisions(isForDivisionsLocal);
  }, [currentPoll]);

  useEffect(() => {
    setIsForAllEmployees(!(isForDivisions || isForOrganizations));
  }, [isForDivisions, isForOrganizations]);
  return (
    <div className={style.info}>
      <p>
        Дата создания:{' '}
        {currentPoll.created ? moment(currentPoll.created, SERVER_DATE_MASK).format(PICKER_DATE_MASK) : 'Не указана'}
      </p>
      <p>Автор: {`${currentPoll.author.lastName} ${currentPoll.author.name} ${currentPoll.author.middleName}`}</p>
      <p>
        Дата начала:{' '}
        {currentPoll.startDate
          ? moment(currentPoll.startDate, SERVER_DATE_MASK).format(PICKER_DATE_MASK)
          : 'Не указана'}
      </p>
      <p>
        Дата окончания:{' '}
        {currentPoll.stopDate ? moment(currentPoll.stopDate, SERVER_DATE_MASK).format(PICKER_DATE_MASK) : 'Не указана'}
      </p>
      <p>Статус: {PollTabsToRus[currentPoll.status]}</p>
      <p className={style.tags}>
        Кому: {isForAllEmployees ? <span className={style.tag}>Всем сотрудникам</span> : null}
        {!isForAllEmployees &&
          currentPoll.divisions.map(division => (
            <span className={style.tag} key={division?.name}>
              {division?.name}{' '}
            </span>
          ))}
        {!isForAllEmployees &&
          currentPoll.organizations.map(organization => (
            <span className={style.tag} key={organization?.name}>
              {organization?.name}{' '}
            </span>
          ))}
      </p>
    </div>
  );
};

export default CommonInfo;
